module.exports = "/_next/static/images/dune-network-logo-00605fb026b0104217a91a8d1518d88f.svg";